import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M103.5 251.7L285 70.7l-33-32.5-148.5 148.6L38 121.3 5 153.8"
})), 'CheckmarkIcon');